import { Directive, ViewContainerRef, TemplateRef, Input } from '@angular/core';

@Directive({
  selector: '[ngTransclude]'
})
export class NgTranscludeDirective {
  protected transclude: TemplateRef<any>;

  constructor(
    public viewContainerRef: ViewContainerRef
  ) {}

  @Input()
  set ngTransclude(templateRef: TemplateRef<any>) {
    this.transclude = templateRef;
    if (templateRef) {
      this.viewContainerRef.createEmbeddedView(templateRef);
    }
  }

  get ngTransclude(): TemplateRef<any> {
    return this.transclude;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/achoo-tabs/ng-transclude.directive.ts